import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import select_email_template_image from "../../assets/images/select_email_template_image.png";
import EmailTemplateModal from "../../components/modals/EmailTemplateModal";

const SelectEmailTemplate = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [select, setSelect] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img src={hamburger_icon} className="object-contain" />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Email Setup" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Email Template</p>
      </div>

      <div className="ml-4 mt-8 flex flex-wrap w-[90%] justify-start">
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
        <div
          className="border-2 cursor-pointer rounded-3xl w-[12rem] flex justify-center mx-4 mb-8"
          onClick={() => setSelect(true)}
        >
          <div>
            <img
              src={select_email_template_image}
              alt="select email template"
              className="w-32 object-contain my-2"
            />
          </div>
        </div>
      </div>

      {select ? <EmailTemplateModal setSelect={setSelect} /> : null}
    </div>
  );
};

export default SelectEmailTemplate;
